module.exports = __webpack_public_path__ + "static/division-shadows-do-985d0988ba60d386b11493dfaf724b58.png";